// Thông báo OS (new Notification) hiện NGAY TỪ TRANG khi có tin nhắn mà tab KHÔNG được nhìn
// (ẩn ở tab khác HOẶC cửa sổ trình duyệt nằm sau app khác).
//
// Vì sao cần: trước đây web bỏ hẳn new Notification in-app, chỉ dựa vào Web Push (service worker).
// Trên desktop, Web Push hay RỚT sau tin ĐẦU TIÊN (subscription chập chờn / trình đẩy gom-hoãn) ->
// "chỉ hiện tbao tin đầu, sau đó im". Trong khi đó trang nhận tin qua SOCKET rất đều (âm + toast tin
// nào cũng có) -> cho trang tự bắn thông báo OS thì tin NÀO cũng được báo.
//
// Chống TRÙNG: sw.js đã chỉnh — khi CÒN cửa sổ app mở thì KHÔNG hiện push nữa (để trang lo); push chỉ
// hiện khi app đã ĐÓNG hẳn.
export function showOsNotification({ title, body, tag, onClick }) {
  try {
    if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
    // Đang NHÌN tab (hiển thị + cửa sổ đang focus) -> đã có toast in-app, khỏi bắn OS cho khỏi phiền.
    // document.hasFocus()=false khi tab ở nền hoặc cửa sổ trình duyệt bị app khác che -> lúc đó MỚI bắn.
    if (!document.hidden && typeof document.hasFocus === 'function' && document.hasFocus()) return;
    const n = new Notification(title || 'Tin nhắn mới', {
      body: body || '',
      icon: '/icon-192.png',
      badge: '/badge-96.png',
      tag: tag || undefined,       // cùng hội thoại -> gộp theo tag
      renotify: !!tag,             // nhưng vẫn báo lại khi có tin mới (renotify cần có tag)
    });
    n.onclick = () => {
      try { window.focus(); } catch { /* ignore */ }
      try { onClick && onClick(); } catch { /* ignore */ }
      n.close();
    };
  } catch { /* trình duyệt chặn / lỗi -> bỏ qua, không làm hỏng luồng tin */ }
}
